import template from './template.html';
import './styles.css';

controller.$inject = ['SchedulesService', 'DateService'];

export function controller(SchedulesService, DateService) {
    const vm = this;
    vm.convert = DateService.convertToJSPLCDate;
    vm.loading = true;
    vm.allocatedPercentage = allocatedPercentage;

    vm.sort = 'start';
    vm.setSortOrder = setSortOrder;
    vm.isSortedBy = isSortedBy;

    SchedulesService.getSchedules().then(data => {
        if (data) {
            for (var i = 0; i < data.length; i++) {
                data[i].allocatedPercentage = vm.allocatedPercentage(data[i]);
            }
        }
        vm.schedules = data;
        vm.loading = false;
    });

    function allocatedPercentage(schedule) {
        if (schedule) {
            const shifts = schedule.items || 1;
            const allocated = schedule.allocated || 0;

            return (allocated / shifts * 100).toFixed(2);
        }
        return 0;
    }

    function setSortOrder(propertyName) {
        vm.sort = vm.sort === propertyName ? '-' + propertyName : propertyName;
    }

    function isSortedBy(propertyName, direction) {
        if (vm.sort.indexOf(propertyName) >= 0) {
            if (direction == 'desc' && vm.sort.substring(0, 1) == '-') {
                return true;
            }
            if (direction == 'asc' && vm.sort.substring(0, 1) != '-') {
                return true;
            }
        }
        return false;
    }
}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('schedules', {
        controller: controller,
        controllerAs: 'vm',
        parent: 'authorised',
        template: template,
        url: ''
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/authorised/schedulelist/index.js